import { AxiosError } from "axios";
import { useApi } from "../hooks/useApi";
import { IRegisterFormResidentData, IRegisterFormTraveler } from "../interfaces/formLoginRegister/dataFormRegister.ts";

//use axios instance
const api = useApi();

export async function registerUser(RegisterFormData: IRegisterFormResidentData | IRegisterFormTraveler | {}): Promise<boolean> {
  try {

    const response = await api.post(`auth/signup`, RegisterFormData, { headers: { "Content-Type": "application/json", "Accept": "application/json" } });
    if (response.status === 201) { //sucess register
      return true
    }

    return false //failure register

  } catch (error) {

    throw error
  }
}

export async function checkPseudoAlreadyExists(pseudo: string): Promise<boolean> {
  try {
    // capitalization leters first into pseudo
    const pseudoCapitalized = pseudo.charAt(0).toUpperCase() + pseudo.slice(1).toLowerCase();

    const { data } = await api.post(`auth/existing/pseudo`, { pseudoCapitalized }, { headers: { "Content-Type": "application/json", "Accept": "application/json" } });

    return data.isPseudoExist

  } catch (error) {

    return true
  }
}

//fonction pour demander la suppression du compte
export async function deleteAccount() {
  try {
    const response = await api.delete(`/auth/delete-account`);
    return response;
  } catch (error) {


    if (error instanceof AxiosError) {
      if (error.response?.data.message === "Le compte est déjà marqué comme supprimé.") {
        throw error.response?.data.message;
      }
    }

    throw new Error('Impossible de supprimer le compte. Veuillez réessayer.');
  }
}